import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ListService } from '../../../services/list.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Constants } from 'src/app/app.constants';

@Component({
  selector: 'app-voucher-library-dialog',
  templateUrl: './voucher-library-dialog.component.html',
  styleUrls: ['./voucher-library-dialog.component.scss'],
})
export class VoucherLibraryDialogComponent implements OnInit {
  loading = false;
  designs: any[] = [];

  constructor(
    public matDialogRef: MatDialogRef<VoucherLibraryDialogComponent>,
    private listService: ListService,
    private constants: Constants
  ) {}

  ngOnInit(): void {
    this.getDesigns();
  }

  getDesigns(): void {
    this.loading = true;
    this.listService
      .getList('vouchers')
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.designs = res;
          }
        },
        error: (res: HttpErrorResponse) => {
          this.constants.snack(res.error.message);
        },
      })
      .add(() => (this.loading = false));
  }
}
